import styles from "./BannerTemporadasPPE.module.css";
import banner from "../../../assets/img/BannerTemporadasPPE/BannerTemporadasPPE3.jpg";
import bannerSmall from "../../../assets/img/BannerTemporadasPPE/BannerSmallTemporadasPPE3.jpg";

import pago_evento_inicio_pre from "../../../assets/img/BannerTemporadasPPE/pago_evento_inicio_pre.png";
import pago_evento_inicio_mobile_pre from "../../../assets/img/BannerTemporadasPPE/pago_evento_inicio_mobile_pre.png";
import { Container } from "react-bootstrap";
import Button from "react-bootstrap/Button";

export const BannerTemporadasPPE2 = () => {
  return (
    <>
      <Container
        id="big"
        className={styles["contenedor"] + " d-none d-xl-block d-lg-block"}
        fluid
      >
        <img
          src={
            sessionStorage.getItem("tipoCliente") === "POS"
              ? banner
              : pago_evento_inicio_pre
          }
          className={styles.imagen}
        />
      </Container>

      <Container className={styles.contenedorSmall} style={{ padding: "0" }}>
        <div
          id="small"
          className={styles["contenedor"] + " d-lg-none d-xl-none"}
        >
          <img
            src={
              sessionStorage.getItem("tipoCliente") === "POS"
                ? bannerSmall
                : pago_evento_inicio_mobile_pre
            }
            className={styles.imagen}
          />
        </div>
        <div id="small" className="d-lg-none d-xl-none"></div>
      </Container>
    </>
  );
};
